var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-1 0 0 1 100 0)",
    fill: "#4375C5",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-1 0 0 1 100 0)",
    fill: "url(#paint0_radial_5490_417245)",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5607 80.5542H29.9357L47.594 58.2459L24.9023 35.5542H40.9357C42.319 35.5542 43.4357 36.6709 43.4357 38.0542C43.4357 39.4375 42.319 40.5542 40.9357 40.5542H36.969L54.2773 57.8625L40.269 75.5542H52.3107L70.7273 54.7292C71.644 53.6959 73.2273 53.5959 74.2523 54.5125C75.2857 55.4292 75.3857 57.0042 74.469 58.0375L54.5523 80.5459L54.5607 80.5542Z",
    fill: "#6DFBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4451 51.3042C64.7784 51.3042 64.1034 51.0375 63.6118 50.5042L41.1118 26.3375C40.1701 25.3292 40.2284 23.7458 41.2368 22.8042C42.2451 21.8625 43.8284 21.9208 44.7701 22.9292L67.2701 47.0958C68.2118 48.1042 68.1534 49.6875 67.1451 50.6292C66.6618 51.0792 66.0534 51.2958 65.4451 51.2958V51.3042Z",
    fill: "#6DFBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1111 34.4458C73.1111 34.4458 73.9111 35.2541 73.9111 36.2458C73.9111 37.2375 73.1027 38.0458 72.1111 38.0458C71.1194 38.0458 70.3027 37.2375 70.3027 36.2458C70.3027 35.2541 71.1111 34.4458 72.1111 34.4458Z",
    fill: "#6DFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3117 27.7792C67.7867 27.7792 68.9867 28.9792 68.9867 30.4542C68.9867 31.9292 67.7867 33.1292 66.3117 33.1292C64.8367 33.1292 63.6367 31.9292 63.6367 30.4542C63.6367 28.9792 64.8367 27.7792 66.3117 27.7792Z",
    fill: "#6DFBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3021 19.4458C62.1437 19.4458 63.6354 20.9375 63.6354 22.7791C63.6354 24.6208 62.1437 26.1125 60.3021 26.1125C58.4604 26.1125 56.9688 24.6208 56.9688 22.7791C56.9688 20.9375 58.4604 19.4458 60.3021 19.4458Z",
    fill: "#6DFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5490_417245",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.747 51.3158) rotate(90) scale(97.1053 69.5367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F94D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F94D3",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarouselArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carousel-arrow-right.eef047e97c571e4898cd967eb0b26626.svg";